import { Mutations } from 'vuex-smart-module';

import SpecialOfferState from './state';

export default class SpecialOfferMutations extends Mutations<SpecialOfferState> {}
